import * as Immutable from 'immutable';

export type UserImagePayload = {
	id: number
	id_user: number
	id_user_image_status: number
	name: string
	fileid: string
	filename: string
	original_filename: string
	original_format?: string | null
	dpi?: number | null
	filesize: number
	width: number
	height: number
	date_added: string
}

interface IUserImageStore {
	id: string
	name: string
	filename: string
	original_filename: string
	original_format: string | null
	dpi: number | null
	fileid: string
	filesize: number
	width: number
	height: number
}

const defaultUserImageStore = Immutable.Record<IUserImageStore>({
	id: undefined,
	name: undefined,
	filename: undefined,
	original_filename: undefined,
	original_format: null,
	dpi: null,
	fileid: undefined,
	filesize: 0,
	width: 0,
	height: 0,
});

export class UserImageStore extends defaultUserImageStore implements IUserImageStore {}
